// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zfdMn","question":"styles_question__VH6sw","description":"styles_description__mbIPq"};